<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import providerApi from '@/services/api/provider.api'
import codeApi from '@/services/api/code.api'
import locationApi from '@/services/api/location.api'
import appointmentsApi from '@/services/api/appointments.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'
import ServiceTypes from '../../utils/constants/serviceType'
import thrpyApi from '@/services/api/thrpy.api'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Espacios Disponibles',
      routes: ['Informes', 'Espacios Disponibles'],
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          providers: [],
          specialists: [],
          periods: [],
          municipalities: [],
          locationServices: [],
          serviceTypes: [],
          disciplines: [],
        },
        filters: {
          academicYear: null,
          provider: null,
          specialist: null,
          period: null,
          municipality: null,
          locationService: null,
          serviceType: null,
          discipline: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          class: 'col-md-4',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'period',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Periodo',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar Periodo',
          validations: 'required',
          clearable: false,
          class: 'col-md-4',
          options: this.model.search.collections.periods,
          value: this.model.search.filters.period,
          disabled: this.model.search.collections.periods.length <= 0,
          onChanged: this.onChangePeriod,
        },
        {
          name: 'municipality',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Municipio',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar el municipio',
          validations:
            (this.model.search.filters.provider === null ||
              this.model.search.filters.provider === undefined) &&
            (this.model.search.filters.municipality === null ||
              this.model.search.filters.municipality === undefined)
              ? 'required'
              : '',
          clearable: false,
          class: 'col-md-4',
          options: this.model.search.collections.municipalities,
          value: this.model.search.filters.municipality,
          disabled: this.model.search.collections.municipalities.length <= 0,
          onChanged: this.onChangeMunicipality,
        },
        {
          name: 'provider',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Proveedor',
          placeholder: 'Seleccionar',
          validations:
            (this.model.search.filters.municipality === null ||
              this.model.search.filters.municipality === undefined) &&
            (this.model.search.filters.provider === null ||
              this.model.search.filters.provider === undefined)
              ? 'required'
              : '',
          error: 'Favor de seleccionar un proveedor.',
          clearable: false,
          class: 'col-md-4',
          options: this.model.search.collections.providers,
          value: this.model.search.filters.provider,
          onChanged: this.onChangeProvider,
          disabled:
            this.model.search.collections.providers.length <= 1,
        },
        {
          name: 'specialist',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Especialista',
          placeholder: 'Seleccionar',
          clearable: false,
          class: 'col-md-4',
          options: this.model.search.collections.specialists,
          value: this.model.search.filters.specialist,
          disabled:
            this.model.search.collections.specialists.length <= 1,
        },
        {
          name: 'locationService',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Lugar de Servicio',
          placeholder: 'Seleccionar',
          clearable: false,
          class: 'col-md-4',
          options: this.model.search.collections.locationServices,
          value: this.model.search.filters.locationService,
          disabled: this.model.search.collections.locationServices.length <= 1,
        },
        {
          name: 'serviceType',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Tipo de Servicio',
          placeholder: 'Seleccionar',
          clearable: false,
          class: 'col-md-6',
          options: this.model.search.collections.serviceTypes,
          value: this.model.search.filters.serviceType,
          onChanged: this.onChangeServietype,
        },
        {
          name: 'discipline',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Disciplina',
          placeholder: 'Seleccionar',
          clearable: false,
          class: 'col-md-6',
          options: this.model.search.collections.disciplines,
          value: this.model.search.filters.discipline,
          disabled: this.model.search.collections.disciplines.length <= 1,
        },
      ]
    },
  },
  async mounted() {
    await this.setFilters()
  },
  methods: {
    async setFilters() {
      await AcademicYearServices.getExistingPeisAcademicYears().then((res) => {
        this.model.search.collections.academicYears = res.data
        let years = (this.model.search.filters.academicYear = res.data.filter(
          (x) => x.selected
        ))
        this.model.search.filters.academicYear =
          years.length > 0 ? years[0] : null
        this.onChangeAcademicYear()
      })

      var evaluationServices = [
        ServiceTypes.EvaluacionInicial,
        ServiceTypes.EvaluacionAdicional,
        ServiceTypes.EvaluacionTrianual,
        ServiceTypes.Reevaluacion,
      ]

      await codeApi
        .GetTransitionalServicesFilters()
        .then(
          (res) =>
            (this.model.search.collections.serviceTypes = res.data.filter((x) =>
              evaluationServices.includes(x.id)
            ))
        )
    },
    async onChangeAcademicYear() {
      this.model.search.filters.provider = null
      this.model.search.collections.providers = []
      this.model.search.filters.period = null
      this.model.search.collections.periods = []
      this.model.search.filters.municipality = null
      this.model.search.collections.municipalities = []
      this.model.search.filters.locationService = null
      this.model.search.collections.locationServices = []

      await this.getPeriod()
      await this.getMunicipality()
    },
    async onChangeMunicipality() {
      this.model.search.filters.provider = null
      this.model.search.collections.providers = []
      this.model.search.filters.locationService = null
      this.model.search.collections.locationServices = []
      await this.getProvider()
      if (this.hasValue(this.model.search.filters.provider)) {
        this.getLocationService()
      }
    },
    async onChangePeriod() {
      this.model.search.filters.specialist = null
      this.model.search.collections.specialists = []

      this.model.search.filters.locationService = null
      this.model.search.collections.locationServices = []

      this.model.search.filters.provider = null
      this.model.search.collections.providers = []

      await this.getProvider()
    },

    async onChangeProvider() {
      this.model.search.filters.specialist = null
      this.model.search.collections.specialists = []

      this.model.search.filters.locationService = null
      this.model.search.collections.locationServices = []

      if (
        this.model.search.filters.academicYear != null &&
        this.model.search.filters.provider != null
      ) {
        await this.getSpecialist();
      }

      if (
        this.model.search.filters.municipality != null &&
        this.model.search.filters.provider != null
      ) {
        await this.getLocationService()
      }
    },
    async onChangeServietype() {
      this.model.search.filters.discipline = null

      await this.getDiscipline()
    },
    async getProvider() {
      this.model.search.filters.provider = null
      if (
        this.model.search.filters.academicYear &&
        this.model.search.filters.period &&
        this.model.search.filters.municipality
      ) {
        const { data } = await providerApi
          .getProvidersAvailable(
            this.model.search.filters.academicYear?.id,
            this.model.search.filters.period?.id,
            this.model.search.filters.municipality?.id
          );
        
        this.model.search.collections.providers = data;

        if (data.length == 1) {
          this.model.search.filters.provider = data[0];
          await this.getSpecialist();
          await this.getLocationService();
        }
      }
    },
    async getPeriod() {
      await appointmentsApi
        .getAppointmentsFilters({
          academicYearId: this.model.search.filters.academicYear?.id,
        })
        .then((res) => {
          this.model.search.collections.periods = res.data
        })
    },
    async getMunicipality() {
      await locationApi
        .getMunicipalities({
          academicYearId: this.model.search.filters.academicYear?.id,
        })
        .then((res) => {
          this.model.search.collections.municipalities = res.data
        })
    },
    async getLocationService() {
      const { data } = await locationApi
        .getLocationService({
          academicYearId: this.model.search.filters.academicYear?.id,
          municipalityId: this.model.search.filters.municipality?.id,
          companyId: this.model.search.filters.provider?.id,
        });

      this.model.search.collections.locationServices = data;

      if (data.length == 1) {
        this.model.search.filters.locationService = data[0];
      }
    },
    async getSpecialist() {
      const { data } = await thrpyApi.getTherapyEspecialist({
        academicYearId: this.model.search.filters.academicYear?.id,
        companyId: this.model.search.filters.provider?.id,
      });

      this.model.search.collections.specialists = data;

      if (data.length == 1) {
        this.model.search.filters.specialist = data[0];
      }
    },
    async getDiscipline() {
      await codeApi
        .GetTransitionalDisciplineFilters({
          serviceTypeId: this.model.search.filters.serviceType?.id,
        })
        .then((res) => {
          this.model.search.collections.disciplines = res.data
        })
    },
    async onHandlerSearch() {
      this.process()
    },
    hasValue(paramValue) {
      return paramValue !== null && paramValue !== undefined
    },
    async process() {
      if (
        this.hasValue(this.model.search.filters.academicYear) &&
        this.hasValue(this.model.search.filters.period) &&
        (this.hasValue(this.model.search.filters.municipality) ||
          this.hasValue(this.model.search.filters.provider))
      ) {
        await ReportServices.getReport('availablespace', {
          academicYearId: this.model.search.filters.academicYear?.id,
          month: this.model.search.filters.period?.id,
          municipalityId: this.model.search.filters.municipality?.id,
          companyId: this.model.search.filters.provider?.id,
          locationId: this.model.search.filters.locationService?.id,
          serviceTypeId: this.model.search.filters.serviceType?.id,
          disciplineId: this.model.search.filters.discipline?.id,
          specialistId: this.model.search.filters.specialist?.id,
        }).then((res) => DocumentServices.Download(res.data))
      }
    },
  },
}
</script>
